import type { RefObject } from 'react';
import NextLink, { LinkProps } from '~/client/shared/NextLink';

type Props = {
  id?: string;
  href: LinkProps['href'];
  className?: string;
  innerRef?: RefObject<HTMLAnchorElement>;
  target?: '_blank';
  shallow?: boolean;
};

const SiteBridgeLink: FC<Props> = ({
  href,
  innerRef,
  shallow = false,
  ...rest
}) => <NextLink href={href} shallow={shallow} ref={innerRef} {...rest} />;

export default SiteBridgeLink;
